(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
      this._navBound = false;
      this._dur = 400;
      this._closing = false;
      this.querySelectorAll('.product-media-modal__item img').forEach(img => {
        img.addEventListener('click', () => this.hide());
      });
    }

    show(opener) {
      this.openedBy = opener;
      this._sourceEl = this._findSourceImg(opener);
      const sourceRect = this._sourceEl ? this._sourceEl.getBoundingClientRect() : null;

      // Start with transparent backdrop and hidden content for fly-in
      if (sourceRect) {
        this.style.backgroundColor = 'transparent';
        this._setContentVisible(false);
      }

      super.show(opener);
      this.showActiveMedia();
      this._initNav();

      if (sourceRect) {
        const modalImg = this._activeModalImg();
        if (modalImg) {
          requestAnimationFrame(() => {
            const targetRect = modalImg.getBoundingClientRect();
            // Fade backdrop in sync with fly animation
            this.style.transition = `background-color ${this._dur}ms cubic-bezier(.22,1,.36,1)`;
            this.style.backgroundColor = '';
            this._animate(modalImg.src || modalImg.currentSrc, sourceRect, targetRect, () => {
              this.style.transition = '';
              this._setContentVisible(true);
            });
          });
        } else {
          this.style.backgroundColor = '';
          this._setContentVisible(true);
        }
      }
    }

    hide() {
      if (this._closing) return;
      this._closing = true;

      const modalImg = this._activeModalImg();
      const pageImg = this._findPageImg();
      const targetRect = pageImg ? pageImg.getBoundingClientRect() : null;
      const modalRect = modalImg ? modalImg.getBoundingClientRect() : null;

      // Hide content, fade backdrop out in sync with fly animation
      this._setContentVisible(false);
      this.style.transition = `background-color ${this._dur}ms cubic-bezier(.22,1,.36,1)`;
      this.style.backgroundColor = 'transparent';

      if (modalRect && targetRect && modalImg) {
        this._animate(modalImg.src || modalImg.currentSrc, modalRect, targetRect, () => this._finishClose());
      } else {
        setTimeout(() => this._finishClose(), this._dur);
      }
    }

    _finishClose() {
      this._closing = false;
      this.style.transition = '';
      this.style.backgroundColor = '';
      this._setContentVisible(true);
      super.hide();
      window.pauseAllMedia();
    }

    _setContentVisible(visible) {
      this.querySelectorAll('.product-media-modal__dialog, .product-media-modal__toggle, .product-media-modal__nav')
        .forEach(el => el.style.opacity = visible ? '' : '0');
    }

    _findSourceImg(opener) {
      if (!opener) return null;
      const grid = opener.closest('.product__media-grid-item');
      if (grid) return grid.querySelector('img');
      const slide = opener.closest('.product__media-item');
      if (slide) return slide.querySelector('.product__media img');
      return null;
    }

    _findPageImg() {
      const modalImg = this._activeModalImg();
      if (!modalImg) return this._sourceEl;
      const mediaId = modalImg.dataset.mediaId;
      if (!mediaId) return this._sourceEl;
      const gridBtn = document.querySelector(`.product__media-grid-item [data-media-id="${mediaId}"]`);
      if (gridBtn) {
        const img = gridBtn.closest('.product__media-grid-item')?.querySelector('img');
        if (img) return img;
      }
      const slideEl = document.querySelector(`.product__media-item[data-media-id$="-${mediaId}"]`);
      if (slideEl) {
        const img = slideEl.querySelector('.product__media img');
        if (img) return img;
      }
      return this._sourceEl;
    }

    _activeModalImg() {
      const slider = this.querySelector('.js-popup-slider');
      if (!slider || !slider.swiper) return null;
      const slide = slider.swiper.slides[slider.swiper.activeIndex];
      return slide ? slide.querySelector('img') : null;
    }

    _animate(src, fromRect, toRect, onDone) {
      const el = document.createElement('img');
      el.src = src;
      Object.assign(el.style, {
        position: 'fixed', zIndex: '9999', pointerEvents: 'none',
        top: fromRect.top + 'px', left: fromRect.left + 'px',
        width: fromRect.width + 'px', height: fromRect.height + 'px',
        objectFit: 'cover', borderRadius: 'var(--border-radius-main)',
        transition: `top ${this._dur}ms cubic-bezier(.22,1,.36,1), left ${this._dur}ms cubic-bezier(.22,1,.36,1), width ${this._dur}ms cubic-bezier(.22,1,.36,1), height ${this._dur}ms cubic-bezier(.22,1,.36,1), object-fit ${this._dur}ms`
      });
      document.body.appendChild(el);

      requestAnimationFrame(() => {
        el.style.top = toRect.top + 'px';
        el.style.left = toRect.left + 'px';
        el.style.width = toRect.width + 'px';
        el.style.height = toRect.height + 'px';

        setTimeout(() => {
          el.remove();
          if (onDone) onDone();
        }, this._dur);
      });
    }

    showActiveMedia() {
      const mediaId = this.openedBy.getAttribute("data-media-id");
      const isVariantSlot = this.openedBy.closest('[data-variant-slot]') !== null;
      const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);

      if (activeMedia && activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }

      const popupSlider = this.querySelector('.js-popup-slider');
      if (popupSlider && popupSlider.swiper) {
        if (isVariantSlot) {
          popupSlider.swiper.slideTo(0, 0);
        } else {
          const sectionId = this.id.replace('ProductModal-', '');
          const slides = Array.from(popupSlider.querySelectorAll('.swiper-slide'));
          const targetIndex = slides.findIndex(s => s.dataset.mediaModalId === sectionId + '-' + mediaId);
          if (targetIndex >= 0) popupSlider.swiper.slideTo(targetIndex, 0);
        }
        this._updateCounter(popupSlider.swiper);
      }
    }

    _initNav() {
      const popupSlider = this.querySelector('.js-popup-slider');
      if (!popupSlider || !popupSlider.swiper) return;
      const swiper = popupSlider.swiper;
      const prevBtn = this.querySelector('.product-media-modal__nav-prev');
      const nextBtn = this.querySelector('.product-media-modal__nav-next');

      if (!this._navBound) {
        this._navBound = true;
        if (prevBtn) prevBtn.addEventListener('click', () => swiper.slidePrev());
        if (nextBtn) nextBtn.addEventListener('click', () => swiper.slideNext());
        swiper.on('slideChange', () => this._updateCounter(swiper));
      }
      this._updateCounter(swiper);
    }

    _updateCounter(swiper) {
      const el = this.querySelector('.product-media-modal__nav-current');
      if (el) el.textContent = swiper.activeIndex + 1;
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
